class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    const product_url = button.getAttribute('data-product-url');    
    
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      const modal_wrap = document.querySelector('quick-add-modal [id^="QuickAddInfo-"]'); 
      if (modal){
        modal_wrap.innerHTML = '';
        this.openedBy = button;
        document.body.classList.add('overflow-hidden');
        modal.setAttribute('open', '');
     
        fetch(product_url).then((response) => response.text()).then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const main_product = html.querySelector('.layout-main-product');
  
          if (main_product?.innerHTML.trim().length) {
            var element = main_product.querySelector(".pdp-alsoloved__container");
            if(element){
              element.parentNode.removeChild(element);
            }
            var element1 = main_product.querySelector(".pdp-section__recommendations");
            if(element1){
              element1.parentNode.removeChild(element1);
            }
            
            modal_wrap.innerHTML = main_product.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
        
        const button1 = document.querySelector('quick-add-modal [id^="ModalClose-"]'); 
        button1.addEventListener('click', () => {
          const modal1 = document.querySelector('quick-add-modal');
          modal1.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
        });
        
      }
    });
  }
  
}
customElements.define('modal-opener', ModalOpener);

const button = document.querySelector('.header-nav__toggle');

button.addEventListener('click', () => {      
  const navigation = document.querySelector('#mobile-navigation-drawer'); 
  if (navigation){
    navigation.classList.add('open_new');        
  }
});

const close_btn = document.querySelector('#mobile-navigation-drawer [id^="MobileNavigationClose-"]'); 

close_btn.addEventListener('click', () => {      
  const navigation = document.querySelector('#mobile-navigation-drawer'); 
  if (navigation){
    navigation.classList.remove('open_new');        
  }
});

    
    